/*
 *   File : e-sign.js
 *   Author : https://evoqins.com
 *   Description : Onboarding step  - E-sign page
 *   Integrations : 
 *   Version : 1.0.0
 *   Date : 26-09-2022  
*/

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"
import { Modal } from "bootstrap";
import { toast } from "react-toastify";


// *********** Components ***************//  
import { Icon } from "../../../Component/Icon";
import { PrimaryButton } from "../../../Component/Buttons";
import { _getSignupProgress } from "../../../Helper";
import { KycStatusModal } from "../../../Component/Modal";
import Store from "../../../Store/store";
import { APIService } from "../../../Service";

// ***********  Assets ***************// 
import Inactive from "../../../Assets/Images/check-box.svg";
import ActiveCheckbox from "../../../Assets/Images/check-box-active.svg";


// *********** Styles ***************//  
import styles from "../../../Style/Component/login.module.scss";



function ESign(props) {

    const navigate = useNavigate();
    const [selectTerms, setSelectTerms] = useState(true);
    const [loading, setLoading] = useState(false);
    const [statusModal, setStatusModal] = useState(false);


    useEffect(() => {
        if (statusModal === true) {
            let kyc_status = new Modal(document.getElementById('kyc-status-modal'));
            kyc_status.show();
        }
    }, [statusModal]);

    const _handleInitiateESign = () => {
        setLoading(true);
        _createEsign();
    };

    //handle select terms and condition
    const _handleSelectTerms = () => {
        setSelectTerms((selectTerms) => !selectTerms);
    };

    // handle modal close
    const _handleModalClose = () => {
        // Closing modal
        var button = document.getElementById("kyc-status-modal-close-btn");
        button.click();

        setStatusModal(false);

        sessionStorage.removeItem('access_token');
        Cookies.remove('onboarding_refresh_token', { domain: process.env.REACT_APP_DOMAIN, path: '/', expires: 30 });
        Store.dispatch({
            type: 'UPDATE_ONBOARDING_TOKEN',
            payload:
                { refresh_token: null, access_token: null }
        });
        // enable navigation to Home page
        navigate("/", { replace: true, });
    };

    //API- create e-sign 
    const _createEsign = () => {

        let api_version = 2;
        let is_post = false;
        let url = 'kyc/create-esign';
        let data = null;

        APIService(is_post, url, data, null, api_version).then((response) => {
            if (response.status_code === 200 && response.data.redirect_url) {

                let e_sign_window = window.open(response.data.redirect_url, '_blank');

                let timer = setInterval(function () {
                    if (e_sign_window.closed) {
                        clearInterval(timer);
                        _getSignupProgress().then((response) => {
                            if (response.status_code === 200) {
                                let is_esign_success = response.data.kyc_data.status === "KYC_SUBMITTED" ? true : false;
                                let is_auth_configured = localStorage.getItem("is_auth_configured");
                                if (is_esign_success) {

                                    if (is_auth_configured) {
                                        setStatusModal(true);
                                    } else {
                                        props.handleUpdateCurrentStep(7); // Set PIN
                                    }

                                    toast.dismiss();
                                    toast.success("E-Sign completed successfully.", { className: "e-toast", });
                                }
                                setLoading(false);
                            }
                        })
                    }
                }, 1000);

            } else {
                if (!response.data?.redirect_url) {
                    toast.dismiss();
                    toast.error('Something went wrong try again later', {
                        className: "e-toast",
                    });
                } else {
                    toast.dismiss();
                    toast.error(response.message, {
                        className: "e-toast",
                    });
                }

                setLoading(false);
            }
        });
    };


    return (
        <div className="col-sm-10 col-xl-9 mx-auto px-sm-0">
            <div className="e-padding-block-40px-res padding-76px-top padding-150px-bottom position-relative">

                <div className={`${styles.e_onboarding_wrapper_personal_details} e-border-radius-24`}>

                    <div className="row flex-column flex-sm-row justify-content-between align-items-sm-center mb-sm-5 mb-3 row-gap-2">
                        <div className="col">
                            <div className="d-flex gap-3 gap-sm-4">
                                <Icon icon="arrow-back-left"
                                    className="cursor-pointer"
                                    size={24}
                                    onClick={() => props.handleBack()} />
                                <h1 className="e-text-chinese-black  e-font-16-res e-font-20 e-alt-font-poppins e-font-weight-600 line-height-24px mb-0">
                                    E- Sign Documents
                                </h1>
                            </div>
                        </div>

                        <div className="col-10 col-sm-6 col-lg-4">
                            <div className="d-flex align-items-center gap-2">
                                <div className="flex-fill progress h-6 e-bg-lavender e-border-radius-16" role="progressbar" aria-label="Success example" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                                    <div className="progress-bar progress-bar-bg w-100 e-border-radius-16" ></div>
                                </div>
                                <p className='mb-0 e-text-egyptian-blue e-font-12 e-alt-font-poppins e-font-weight-500 line-height-24px'>
                                    Step 5 of 5
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="onboarding-section-wrapper">
                        <p className="e-text-egyptian-blue e-alt-font-poppins e-font-14 e-font-weight-400 line-height-16px mb-4">
                            Your account opening agreement has been created. Please e-sign it by clicking the button below.
                        </p>

                        <img src={require("../../../Assets/Images/Onboarding/e-sign.png")} alt="e-sign" className="col-8 col-md-4" />

                    </div>

                    <div className="row flex-column flex-md-row row-gap-3 justify-content-md-between align-items-md-center margin-top-32px margin-24px-top-res">
                        <div className="col-sm-10 col-md-6">
                            <div className='d-flex align-items-start gap-0-12px'>
                                <img src={selectTerms ? ActiveCheckbox : Inactive}
                                    draggable={false}
                                    className='cursor-pointer width-24px width-20px-res'
                                    alt='checkbox'
                                    onClick={_handleSelectTerms} />
                                <div className="position-relative">
                                    <p className='mb-0  e-text-charleston-green e-font-12 e-alt-font-poppins e-font-weight-500 line-height-18px'>
                                        I agree to the Index Funds Sahi Hai
                                        <a href="https://indexfundssahihai.com/terms"
                                            target="_blank"
                                            className='px-1 e-text-egyptian-blue cursor-pointer text-decoration-hover-underline'>
                                            terms and conditions.
                                        </a>
                                        Also, I assure that I will read KIM & SID of funds before investments.
                                    </p>
                                    <p className={`${selectTerms === false ? "opacity-100" : "opacity-0"} position-absolute top-100 start-0 padding-2px-top mb-0 e-error-message e-font-12`}>
                                        Please select terms and conditions.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-9 col-sm-6 col-md-4">
                            <PrimaryButton name={"E-Sign Document"}
                                loading={loading}
                                disabled={loading}
                                inActive={!selectTerms}
                                className={`w-100 padding-12px-tb padding-8px-tb-res e-font-14`}
                                onPress={_handleInitiateESign} />
                        </div>
                    </div>
                </div>
            </div>

            {/* kyc status modal  */}
            {
                statusModal === true &&
                <KycStatusModal title={"Almost Done"}
                    image={require("../../../Assets/Images/KYC/kyc-success.webp")}
                    description={"The KYC re-submission  process has been initiated and the process will take 1-3 business days time. We will notify over mail once it is completed"}
                    onCloseModal={_handleModalClose}
                    buttonName={"Understood"}
                    onButtonClick={_handleModalClose}
                />
            }
        </div>

    )
}

export default ESign;